import axios from './axios';
import { ApiUserDto } from './types';

export const sdkSsoLogin = async () => {
  const { data } = await axios.post<ApiUserDto>('/api/ApiUser/SdkSsoLogin');
  return data;
};

